import {
  PaymentMethod,
  PaymentType,
  StripeOrderDTO,
} from "./StripeOrderDTO.ts";

export const STRIPE_PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.Card]: "Carta",
  [PaymentMethod.ApplePay]: "Carta / Apple Pay",
  [PaymentMethod.GooglePay]: "Carta / Google Pay",
  [PaymentMethod.PayPal]: "PayPal",
  [PaymentMethod.Satispay]: "Satispay",
  [PaymentMethod.BankTransfer]: "Bonifico",
  [PaymentMethod.SepaDebit]: "Addebito SEPA",
  [PaymentMethod.RevolutPay]: "Revolut Pay",
  [PaymentMethod.Unknown]: "Sconosciuto",
};

export const STRIPE_PAYMENT_TYPE_LABELS: Record<PaymentType, string> = {
  [PaymentType.OneTime]: "Soluzione unica",
  [PaymentType.Installments]: "Rate",
};

export function describeStripePaymentMethod(
  paymentMethod: PaymentMethod | undefined,
): string {
  return (
    STRIPE_PAYMENT_METHOD_LABELS[paymentMethod || PaymentMethod.Unknown] ??
    paymentMethod
  );
}

export function describeStripePaymentType(
  order: Pick<
    StripeOrderDTO,
    "paymentType" | "numberOfPaidCharges" | "numberOfInstallments"
  >,
): string {
  return order.paymentType === PaymentType.OneTime
    ? STRIPE_PAYMENT_TYPE_LABELS[PaymentType.OneTime]
    : `${STRIPE_PAYMENT_TYPE_LABELS[PaymentType.Installments]}: ${order.numberOfPaidCharges}/${order.numberOfInstallments}`;
}
